import de from '@translations/de/appLoader.json';
import en from '@translations/en/appLoader.json';
import pl from '@translations/pl/appLoader.json';
import sl from '@translations/sl/appLoader.json';
import uk from '@translations/uk/appLoader.json';
import bg from '@translations/bg/appLoader.json';
import cz from '@translations/cz/appLoader.json';
import fr from '@translations/fr/appLoader.json';
import gr from '@translations/gr/appLoader.json';
import it from '@translations/it/appLoader.json';
import pr from '@translations/pr/appLoader.json';
import ru from '@translations/ru/appLoader.json';
import sk from '@translations/sk/appLoader.json';
import sp from '@translations/sp/appLoader.json';
import tr from '@translations/tr/appLoader.json';
import hu from '@translations/hu/appLoader.json';
import { ITranslations } from '@/types/common';
import { AppLoaderTransFields } from './types';

export const appLoaderTranslations: ITranslations<AppLoaderTransFields> = {
  name: 'appLoader',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
